import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { toKey, types } from '@tmap/mmm-core/entityKey';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Dialog } from '@tmap/mmm-style-guide/src/Dialog';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { IconButton } from '@tmap/mmm-style-guide/src/IconButton';
import { Close } from '@tmap/mmm-style-guide/src/Icon';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import miniHandlebars from '@tmap/mmm-core/miniHandlebars';

import { addUserFavorite } from '../../actions/user';
import { saveAndRequestApp } from '../../actions/incentive';
import useCurrentUser from '../../hooks/useCurrentUser';
import { trackOutbound } from '../../lib/analytics';

function ClaimDialog(props) {
  const {
    incentive,
    children,
  } = props;
  const incentiveKey = toKey(types.INCENTIVE, incentive._id);
  const isFavorite = useSelector((state) => (
    (state?.users?.favorites || []).includes(incentiveKey)
  ));
  const dispatch = useDispatch();
  const router = useRouter();
  const user = useCurrentUser();
  const [open, toggleOpenState] = useState(false);

  const handleApplyClick = () => {
    const query = router.asPath.split('?')[1]?.split('&') || [];
    query.push('requestedApp=1');
    const successUrl = `${router.asPath}?${query.join('&')}`;
    if (user?._id) {
      dispatch(saveAndRequestApp(incentiveKey));
      router.push(successUrl, undefined, { shallow: true });
    } else {
      router.push(`/apply/requestApp?login=signup&id=${incentiveKey}&url=${encodeURIComponent(successUrl)}`);
    }
    toggleOpenState(false);
  };

  const handleContinueClick = async () => {
    let url = incentive.applicationUrl;
    if (!isFavorite && user?._id) {
      const uli = await dispatch(addUserFavorite(incentiveKey));
      url = miniHandlebars(url, uli);
    }
    await trackOutbound(url);
    router.push(url);
  };

  const handleCancel = () => {
    toggleOpenState(false);
  };

  // Close the dialog if the incentive ever changes
  useEffect(() => {
    handleCancel();
  }, [incentive]);

  return (
    <>
      {children(toggleOpenState)}
      <Dialog open={open} onClose={handleCancel} maxWidth='xs'>
        <Box component='div' sx={{ padding: (theme) => theme.spacing(3) }}>
          <Grid container alignItems='center' sx={{ marginBottom: 1 }}>
            <Grid item xs>
              <Typography variant='h6' fontWeight={600}>This is a smart move.</Typography>
            </Grid>
            <Grid item>
              <IconButton size='small' onClick={handleCancel}><Close /></IconButton>
            </Grid>
          </Grid>
          <Typography variant='body1' sx={{ marginBottom: 2 }}>
            But this incentive program isn&apos;t being run on the MakeMyMove platform.
            This means you&apos;ll have to apply through an external site.
          </Typography>
          <Button fullWidth variant='contained' color='inverted' onClick={handleApplyClick} sx={{ marginTop: 1.5, marginBottom: 0.5 }}>
            Get Application in My Email
          </Button>
          <Button fullWidth variant='outlined' color='inverted' onClick={handleContinueClick}>Continue to Application</Button>
        </Box>
      </Dialog>
    </>
  );
}

export default ClaimDialog;
